import { usersService } from "@/api/users";
import { classesService } from "@/api/classes";

const state = {
  token: "",
  name: "",
  classesId: "",
  classesName: "",
  avatar: "",
  roles: [],
};

const getters = {
  token: (state) => {
    return state.token;
  },
  name: (state) => {
    return state.name;
  },
  classesId: (state) => {
    return state.classesId;
  },
  classesName: (state) => {
    return state.classesName;
  },
  avatar: (state) => {
    return state.avatar;
  },
  roles: (state) => {
    return state.roles;
  },
};

const mutations = {
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_CLASSESID: (state, classesId) => {
    state.classesId = classesId;
  },
  SET_CLASSESNAME: (state, classesName) => {
    state.classesName = classesName;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
};

const actions = {
  // 设置用户信息
  // setUserInfo({ commit }, profile) {
  //   commit('SET_NAME', profile.name)
  //   commit('SET_AVATAR', profile.avatar)
  //   commit('SET_ROLES', profile.role)
  // },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      usersService
        .getCurrentUser()
        .then((res) => {
          const { data } = res;

          const { roleNames, fullName, avatar, userInfo } = data;
          commit("SET_ROLES", roleNames);
          commit("SET_NAME", fullName);
          commit("SET_CLASSESID", userInfo.classesId);

          if (userInfo.classesId) {
            classesService
              .getClassesById(userInfo.classesId)
              .then((classes) => {
                if (classes) {
                  commit("SET_CLASSESNAME", classes.name);
                }
              });
          }

          commit(
            "SET_AVATAR",
            avatar
              ? /^(http|https):\/\//.test(avatar)
                ? avatar
                : `${process.env.VUE_APP_FILE_URL}/${avatar}`
              : ""
          );
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
